import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeafletMarkerComponent } from './leaflet-marker.component';

@NgModule({
  declarations: [LeafletMarkerComponent],
	exports: [LeafletMarkerComponent],
  imports: [
    CommonModule
  ]
})
export class LeafletMarkerModule { }
